import { z } from 'zod'

export const destinationSchema = z.object({
  server: z.string(),
  tag: z.string().nullish(),
  infos: z.record(z.string(), z.string())
})

export const originSchema = z.object({
  destinationId: z.number(),
  companyName: z.string(),
  userName: z.string(),
  destinationDescription: z.string(),
  connectionKey: z.string(),
  destination: destinationSchema
})

export const templateSchema = z.object({
  value: z.string(),
  name: z.string(),
  template: z.string(),
  header: z.object({
    text: z.string(),
    type: z.string()
  }),
  footer: z.string().nullish(),
  category: z.string(),
  mostUsed: z.boolean(),
  buttons: z.array(z.string()),
  descriptions: z.array(z.string()),
  keys: z.array(z.string())
})

const mediaFileSchema = z.object({
  file: z.instanceof(File),
  url: z.string()
})

export const templateArgSchema = z.object({
  description: z.string(),
  value: z
    .string()
    .min(1, {
      message: 'Campo deve ter no mínimo 1 caracteres'
    })
    .max(255, {
      message: 'Campo deve ter no máximo 255 caracteres'
    }),
  position: z.number(),
  media: mediaFileSchema.optional()
})

export const newChatFormSchema = z.object({
  origin: originSchema,
  phone: z
    .string()
    .min(10, {
      message: 'Telefone deve ter no mínimo 10 caracteres'
    })
    .max(13, {
      message: 'Telefone deve ter no máximo 13 caracteres'
    }),
  template: templateSchema,
  templateArgs: z.record(z.string(), templateArgSchema)
})
